import React, { FC, useContext } from 'react';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { Unit } from '@src/core/Unit';
import { IBreadcrumbsProps } from './models';
import { themeConfig } from './const';

export const Breadcrumbs: FC<IBreadcrumbsProps> = ({ className, style, items, theme = 'light' }) => {
  const { isMobile } = useContext(BreakpointsContext);

  const { mainLinkColor, lastLinkColor, iconView } = themeConfig[theme];

  return (
    <Unit id={'Breadcrumbs'}>
      <Box className={className} style={style} gap={8} wrap>
        {items.map(({ id, name, href, icon, disableNextJs, target }, idx) => {
          const lastItem = idx === items?.length - 1;

          return (
            <Box key={id} gap={8} alignItems="center">
              {!isMobile && icon && <Icon name={icon} size="sm" />}
              <Text
                id={`item_${id}`}
                size="secondary"
                href={href}
                disableNextJs={disableNextJs}
                target={target}
                textDecoration={lastItem ? undefined : 'underline'}
                color={lastItem ? lastLinkColor : mainLinkColor}
              >
                {name}
              </Text>

              {!lastItem && <Icon name="arrowRight" size="sm" view={iconView} />}
            </Box>
          );
        })}
      </Box>
    </Unit>
  );
};
